export const SET_FUNDS_DATA = 'SET_FUNDS_DATA';
export const UPDATE_BANK_ACCOUNTS = 'UPDATE_BANK_ACCOUNTS';
export const DELETE_BANK_ACCOUNT = 'DELETE_BANK_ACCOUNT';
export const UPDATE_CRYPTO_WALLETS = 'UPDATE_CRYPTO_WALLETS';
export const DELETE_CRYPTO_WALLET = 'DELETE_CRYPTO_WALLET';
export const SET_BANK_FORM_ADDRESS_DATA_AVAILABLE = 'SET_BANK_FORM_ADDRESS_DATA_AVAILABLE';
export const SET_PURCHASE_EXCHANGE_RATES = 'SET_PURCHASE_EXCHANGE_RATES';
export const UPDATE_WALLET_BALANCE_AFTER_TRANSACTION = 'UPDATE_WALLET_BALANCE_AFTER_TRANSACTION';
export const UPDATE_WALLETS_BALANCE_AFTER_CRYPTO_TRADE_TRANSACTION = 'UPDATE_WALLETS_BALANCE_AFTER_CRYPTO_TRADE_TRANSACTION';
export const SET_ACCESSING_FUNDS_AGREEMENT_CREATED_AT = 'SET_ACCESSING_FUNDS_AGREEMENT_CREATED_AT';
